export const TicketsOrderStatus = ({ status }) => {
    let result;
    switch (status) {
        case 0: result = <span className="text-info">Новый заказ</span>;
        break;
        case 1: result = <span className="text-info">Ожидает оплаты</span>;
        break;
        case 2: result = <span className="text-success">Оплачено</span>;
        break;
        case 3: result = <span className="text-warning">Возврат выполнен</span>;
        break;
        case 4: result = <span className="text-danger">Отклонен</span>;
        break;
        case 5: result = <span className="text-secondary">Возврат в очереди</span>;
        break;
        default: result = <span>Некорректные данные</span>
    }
    return result;
}

// NewOrder,
// InPayProgress,
// Paid,
// Refund,
// Cencal,
// RefundPayProgress,